const QuestionType = {
  subtype: 'Pregunta'
}

export default QuestionType
